import React, { useState } from 'react';
import { api } from '../../lib/api';
import { toast } from 'sonner';
import { useAuth } from '../../contexts/AuthContext';
import { X } from 'lucide-react';

const EMPTY = { name: '', cedula: '', email: '', phone: '+58', address: '', password: '', contact1_name: '', contact1_phone: '+58', contact2_name: '', contact2_phone: '+58' };

// Inicio de sesión / registro de cliente desde la vitrina (obligatorio para reservar o pedir crédito)
export const AuthModal = ({ open, onClose, slug, onLogged }) => {
  const { login } = useAuth();
  const [tab, setTab] = useState('login');
  const [l, setL] = useState({ email: '', password: '' });
  const [r, setR] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  if (!open) return null;
  const doLogin = async (email, password) => {
    setBusy(true);
    try {
      const d = await login(email, password);
      if (d.user?.must_change_password) { window.location.href = '/change-password'; return; }
      toast.success(`Bienvenido, ${d.user.full_name}`); onLogged && onLogged(d.user); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || 'Credenciales inválidas'); } finally { setBusy(false); }
  };
  const doRegister = async () => {
    setBusy(true);
    try { await api.publicRegister({ ...r, slug }); toast.success('Cuenta creada. Iniciando sesión…'); await doLogin(r.email, r.password); }
    catch (e) { toast.error(e.response?.data?.detail || 'No se pudo registrar'); } finally { setBusy(false); }
  };
  const I = (k, ph, type = 'text') => <input className="cb-input" type={type} placeholder={ph} value={r[k]} onChange={(e) => setR({ ...r, [k]: e.target.value })} data-testid={`register-${k}`} />;
  return (
    <div className="fixed inset-0 z-[60] bg-black/70 grid place-items-center p-3" onClick={onClose} data-testid="mall-auth-modal">
      <div className="bg-[#0B132B] text-white rounded-3xl w-full max-w-md p-6 border border-white/10 max-h-[92vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-center mb-3"><h3 className="cb-display text-3xl">{tab === 'login' ? 'Inicia sesión' : 'Crea tu cuenta'}</h3><button onClick={onClose}><X /></button></div>
        <p className="text-xs text-white/60 mb-3">Para reservar equipos o solicitar crédito necesitas una cuenta de cliente.</p>
        <div className="grid grid-cols-2 gap-1 bg-white/5 rounded-full p-1 text-xs font-bold mb-4">
          {[['login', 'Ingresar'], ['register', 'Registrarme']].map(([k, t]) => <button key={k} onClick={() => setTab(k)} data-testid={`auth-tab-${k}`} className={`rounded-full py-2 ${tab === k ? 'bg-[#FFC857] text-[#0A192F]' : ''}`}>{t}</button>)}
        </div>
        {tab === 'login' ? (
          <div className="space-y-2">
            <input className="cb-input" placeholder="Correo" value={l.email} onChange={(e) => setL({ ...l, email: e.target.value })} data-testid="mall-login-email" />
            <input className="cb-input" type="password" placeholder="Contraseña" value={l.password} onChange={(e) => setL({ ...l, password: e.target.value })} data-testid="mall-login-password" />
            <button className="cb-btn-primary w-full" disabled={busy} onClick={() => doLogin(l.email, l.password)} data-testid="mall-login-submit">Ingresar</button>
          </div>
        ) : (
          <div className="space-y-2">
            {I('name', 'Nombre completo')}{I('cedula', 'Cédula (V-12345678)')}{I('email', 'Correo')}{I('phone', 'Teléfono +58XXXXXXXXXX')}{I('address', 'Dirección')}
            <p className="text-xs text-white/60 pt-1">Contactos de referencia (obligatorios)</p>
            {I('contact1_name', 'Nombre contacto 1')}{I('contact1_phone', '+58XXXXXXXXXX')}{I('contact2_name', 'Nombre contacto 2')}{I('contact2_phone', '+58XXXXXXXXXX')}
            {I('password', 'Crea tu contraseña (mín. 8)', 'password')}
            <button className="cb-btn-primary w-full" disabled={busy} onClick={doRegister} data-testid="mall-register-submit">Crear cuenta</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthModal;
